<template>
  <router-link :to="linkTo" class="text-logo" :class="[sizeClass, serviceClass]">
    <span class="text-logo__icon" v-html="serviceIcon"></span>
    <span class="text-logo__text">{{ serviceName }}</span>
  </router-link>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TextLogoComponent',

  props: {
    size: {
      type: String,
      default: 'medium', // 'small', 'medium', 'large'
    },
    linkTo: {
      type: String,
      default: '/',
    },
  },

  computed: {
    ...mapGetters('app', ['configData']),

    sizeClass() {
      return `text-logo--${this.size}`;
    },

    serviceClass() {
      const service = this.configData?.service_name || 'vid2text';
      const chatbot = this.configData?.chatbot_name || '';

      if (chatbot === 'chaitanyaacademy') return 'text-logo--chaitanya';
      if (chatbot === 'clipcutglobal') return 'text-logo--clipcut';
      if (service === 'meetscribe') return 'text-logo--meetscribe';
      if (service === 'clipcut') return 'text-logo--clipcut';
      if (service === 'harikatha') return 'text-logo--harikatha';
      if (service === 'narezkavideo') return 'text-logo--narezka';
      if (service === 'zvonalitik') return 'text-logo--zvonalitik';
      return 'text-logo--vid2text';
    },

    serviceName() {
      const chatbot = this.configData?.chatbot_name || '';
      const service = this.configData?.service_name || 'vid2text';

      if (chatbot === 'chaitanyaacademy') return 'Chaitanya Academy';
      if (chatbot === 'clipcutglobal') return 'ClipCut';
      if (service === 'meetscribe') return 'MeetScribe';
      if (service === 'clipcut') return 'ClipCut';
      if (service === 'harikatha') return 'Harikatha';
      if (service === 'narezkavideo') return 'Нарезка';
      if (service === 'zvonalitik') return 'Звоналитик';
      return 'Vid2Text';
    },

    serviceIcon() {
      const chatbot = this.configData?.chatbot_name || '';
      const service = this.configData?.service_name || 'vid2text';

      // MeetScribe - микрофон
      if (service === 'meetscribe') {
        return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z"/>
          <path d="M19 10v2a7 7 0 0 1-14 0v-2"/>
          <line x1="12" x2="12" y1="19" y2="22"/>
        </svg>`;
      }

      // ClipCut - ножницы + видео
      if (service === 'clipcut' || chatbot === 'clipcutglobal') {
        return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="6" cy="6" r="3"/>
          <circle cx="6" cy="18" r="3"/>
          <line x1="20" x2="8.12" y1="4" y2="15.88"/>
          <line x1="14.47" x2="20" y1="14.48" y2="20"/>
          <line x1="8.12" x2="12" y1="8.12" y2="12"/>
        </svg>`;
      }

      // Harikatha - книга/лотос
      if (service === 'harikatha') {
        return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
          <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
        </svg>`;
      }

      // Chaitanya Academy - академическая шапка
      if (chatbot === 'chaitanyaacademy') {
        return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M22 10v6M2 10l10-5 10 5-10 5z"/>
          <path d="M6 12v5c3 3 9 3 12 0v-5"/>
        </svg>`;
      }

      // Нарезка - кадры видео
      if (service === 'narezkavideo') {
        return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect width="18" height="18" x="3" y="3" rx="2"/>
          <path d="M7 3v18M17 3v18M3 7h4M17 7h4M3 12h18M3 17h4M17 17h4"/>
        </svg>`;
      }

      // Звоналитик - телефон/аналитика
      if (service === 'zvonalitik') {
        return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
        </svg>`;
      }

      // Vid2Text - видео → текст (по умолчанию)
      return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5"/>
        <rect x="2" y="6" width="14" height="12" rx="2"/>
        <path d="M6 12h4"/>
      </svg>`;
    },
  },
};
</script>

<style scoped>
.text-logo {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  font-weight: 700;
  letter-spacing: -0.02em;
  transition: all 0.2s ease;
}

.text-logo:hover {
  opacity: 0.85;
}

/* Sizes */
.text-logo--small {
  font-size: 16px;
}

.text-logo--small .text-logo__icon {
  width: 20px;
  height: 20px;
}

.text-logo--medium {
  font-size: 20px;
}

.text-logo--medium .text-logo__icon {
  width: 26px;
  height: 26px;
}

.text-logo--large {
  font-size: 24px;
}

.text-logo--large .text-logo__icon {
  width: 32px;
  height: 32px;
}

/* Icon container */
.text-logo__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.text-logo__icon :deep(svg) {
  width: 100%;
  height: 100%;
}

/* Text */
.text-logo__text {
  white-space: nowrap;
}

/* Service-specific colors */

/* Vid2Text - синий */
.text-logo--vid2text {
  color: #3B82F6;
}

.text-logo--vid2text .text-logo__icon {
  color: #3B82F6;
}

/* MeetScribe - индиго/фиолетовый */
.text-logo--meetscribe {
  color: #6366F1;
}

.text-logo--meetscribe .text-logo__icon {
  color: #8B5CF6;
}

/* ClipCut - фиолетовый */
.text-logo--clipcut {
  color: #7C3AED;
}

.text-logo--clipcut .text-logo__icon {
  color: #A855F7;
}

/* Harikatha - оранжевый */
.text-logo--harikatha {
  color: #F59E0B;
}

.text-logo--harikatha .text-logo__icon {
  color: #F97316;
}

/* Chaitanya Academy - индиго/фиолетовый (как в интерфейсе) */
.text-logo--chaitanya {
  color: #6366F1;
}

.text-logo--chaitanya .text-logo__icon {
  color: #8B5CF6;
}

/* Нарезка - красный */
.text-logo--narezka {
  color: #EF4444;
}

.text-logo--narezka .text-logo__icon {
  color: #F87171;
}

/* Звоналитик - зелёный */
.text-logo--zvonalitik {
  color: #10B981;
}

.text-logo--zvonalitik .text-logo__icon {
  color: #34D399;
}

/* Dark theme adjustments */
html[data-bs-theme="dark"] .text-logo--vid2text {
  color: #60A5FA;
}

html[data-bs-theme="dark"] .text-logo--vid2text .text-logo__icon {
  color: #60A5FA;
}

html[data-bs-theme="dark"] .text-logo--meetscribe {
  color: #818CF8;
}

html[data-bs-theme="dark"] .text-logo--meetscribe .text-logo__icon {
  color: #A78BFA;
}

html[data-bs-theme="dark"] .text-logo--clipcut {
  color: #A78BFA;
}

html[data-bs-theme="dark"] .text-logo--clipcut .text-logo__icon {
  color: #C4B5FD;
}

html[data-bs-theme="dark"] .text-logo--harikatha {
  color: #FBBF24;
}

html[data-bs-theme="dark"] .text-logo--harikatha .text-logo__icon {
  color: #FB923C;
}

html[data-bs-theme="dark"] .text-logo--chaitanya {
  color: #818CF8;
}

html[data-bs-theme="dark"] .text-logo--chaitanya .text-logo__icon {
  color: #A78BFA;
}

html[data-bs-theme="dark"] .text-logo--narezka {
  color: #F87171;
}

html[data-bs-theme="dark"] .text-logo--narezka .text-logo__icon {
  color: #FCA5A5;
}

html[data-bs-theme="dark"] .text-logo--zvonalitik {
  color: #34D399;
}

html[data-bs-theme="dark"] .text-logo--zvonalitik .text-logo__icon {
  color: #6EE7B7;
}
</style>
